import { makeObservable, observable } from 'mobx';

import { RenderedServiceList } from '@billing/ui/BillingPage/store/RenderedServiceList';
import { RenderedServiceData } from 'chaika-frontend-types/frontend-cms';

export class BillingPageStore {
    public static Name = 'billingPageStore' as const;

    @observable public renderedServiceList = new RenderedServiceList();

    public constructor() {
        makeObservable(this);
    }

    public addRenderedServices(renderedServices: RenderedServiceData[][]) {
        renderedServices.forEach(item => {
            this.renderedServiceList.add(item);
        });
    }
}

export const billingPageStore = new BillingPageStore();
